// extracted by mini-css-extract-plugin
export default {"container":"AlertsGridLayoutContainer_container__1t8RX"};